export enum GenericReferenceDataTypes {
    AP_ASSERTION = "apAssertion",
    ASSERTION_ATTRIBUTE = "assertionAttribute",
    ASSERTION_SCORE_ASSERTION_STATUS_VALUE_MAP = "assertionScoreAssertionStatusValueMap",
    ASSERTION_SCORE_SERVICE_OFFERING = "assertionScoreServiceOffering",
    ASSERTION = "assertion",
    ASSERTION_STATUS_DEFAULT = "assertionStatusDefault",
    ATTRIBUTE_CLASSIFICATION = "attributeClassification",
    ATTRIBUTE_LABEL = "attributeLabel",
    ATTRIBUTE_TYPE = "attributeType",
    AUTH0_IDENTITY_PROVIDER = "auth0IdentityProvider",
    AVAILABLE_ASSERTION_SCORE_VALUE = "availableAssertionScoreValue",
    AVAILABLE_ASSERTION_STATUS = "availableAssertionStatus",
    AVAILABLE_TRUST_SCORE_VALUE = "availableTrustScoreValue",
    AXNADMIN_USER_PROPERTY_CATEGORY = "axnadminuserpropertycategory",
    CLAIM_STATUS = "claimStatus",
    COMPANY = "company",
    DEPLOYED_POLICY_COMPONENT = "deployedPolicyComponent",
    FALLBACK_SERVICE_MAPPING = "fallbackServiceMapping",
    IDENTITY_PROVIDER = "identityProvider",
    MESSAGING_TEMPLATE = "messagingTemplate",
    EMAIL_TEMPLATE = "selfServiceVerificationEmailTemplates",
    SELF_SERVICE_VERIFICATION_WHITE_LABELED_EMAILS = "selfServiceVerificationWhiteLabeledEmail",
    POLICY_DECISION = "policyDecision",
    RELYING_PARTY = "relyingParty",
    RISK_LEVEL = "riskLevel",
    RP_SERVICE_ATTRIBUTE_PROPERTY = "rpServiceAttributeProperty",
    RP_SERVICE_ATTRIBUTE_PROPERTY_MAP = "rpServiceAttributePropertyMap",
    RP_SERVICE_TEMPLATE = "rpServiceTemplate",
    RP_SERVICE_TYPE = "rpServiceType",
    SCORE_ATTRIBUTE_MAP = "scoreAttributeMap",
    SELF_SERVICE_VERIFICATION_ATTRIBUTE = "selfServiceVerificationAttribute",
    SELF_SERVICE_VERIFICATION_EMAIL_TEMPLATE = "selfServiceVerificationEmailTemplate",
    SERVICE_OFFERING_CATEGORY = "serviceOfferingCategory",
    SERVICE_OFFERING_PACKAGE = "serviceOfferingPackage",
    SERVICE_OFFERING_PROCESSING_TYPE = "serviceOfferingProcessingType",
    SERVICE_OFFERING_REFRESH_RATE_DEFAULT = "serviceOfferingRefreshRateDefault",
    SERVICE_OFFERING_REFRESH_RATE = "serviceOfferingRefreshRate",
    SERVICE_OFFERING = "serviceOffering",
    SERVICE_TYPE = "serviceType",
    SIMPLE_DEPLOYED_POLICY_COMPONENT_CONDITION = "simpleDeployedPolicyComponentCondition",
    SIMPLE_DEPLOYED_POLICY_CONFIG_DECISION = "simpleDeployedPolicyConfigDecision",
    SIMPLE_DEPLOYED_POLICY_CONFIG = "simpleDeployedPolicyConfig",
    TRUST_SCORE_ASSERTION_STATUS_VALUE_MAP = "trustScoreAssertionStatusValueMap",
    TRUST_SCORE_SERVICE_OFFERING = "trustScoreServiceOffering",
    WORKFLOW_CONFIG_PROPERTY = "workflowConfigProperty",
    WORKFLOW_REDIRECT_URL = "workflowRedirectURL",
    WORKFLOW_TEMPLATE = "workflowTemplate",
    CUSTOMER_SUPPORT_TIER = "customerSupportTier"
}